/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_RECEIPTS(state, receipts) {
    state.receipts = receipts
  },
  SET_RECEIPTS_COUNT(state, count) {
    state.receiptsCount = count
  },
}